import { faAppleWhole } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo } from 'react';

import { InsurancePolicy } from '@/types/insurancePolicy';
import Tooltip from '@/ui/components/Tooltip';

import { Props } from './types';

const fieldsRequiredForSync = [
  { fieldName: 'carrier', label: 'Carrier' },
  { fieldName: 'plan', label: '' },
  { fieldName: 'plan_healthie_id', label: 'Plan' },
  { fieldName: 'priority_type', label: 'Order' },
  { fieldName: 'relationship', label: 'Relationship' },
  { fieldName: 'subscriber_id', label: 'Subscriber ID' },
  { fieldName: 'type', label: 'Type' }
];

interface InsurancePolicyWithKeySignature extends InsurancePolicy {
  [key: string]: unknown;
}

const CanSyncWithHealthieIcon = ({ insurancePolicy }: Props) => {
  const hasAllFields = useMemo(
    () =>
      fieldsRequiredForSync.every(
        (field) => !!(insurancePolicy as InsurancePolicyWithKeySignature)[field.fieldName]
      ),
    [insurancePolicy]
  );

  const getColor = useMemo(() => {
    return hasAllFields ? 'text-green-500' : 'text-red-500';
  }, [hasAllFields]);

  const getTooltipContent = useMemo(() => {
    if (hasAllFields) {
      return 'This insurance policy can sync with Healthie.';
    }

    const missingFields = fieldsRequiredForSync.filter(
      (field) => !(insurancePolicy as InsurancePolicyWithKeySignature)[field.fieldName]
    );

    return (
      <>
        <p>This insurance policy cannot sync with Healthie.</p>
        <p>Missing fields:</p>
        <ul>
          {missingFields.map((field) => (
            <li key={field.fieldName}>{field.label}</li>
          ))}
        </ul>
      </>
    );
  }, [hasAllFields, insurancePolicy]);

  return (
    <Tooltip tooltipContent={getTooltipContent}>
      <FontAwesomeIcon
        className={getColor}
        data-testid={`can-sync-with-healthie-icon-${insurancePolicy.id}`}
        icon={faAppleWhole}
      />
    </Tooltip>
  );
};

export default CanSyncWithHealthieIcon;
